module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row8_gameend.2b722265.png";